import axios from '../../localAxios';
import { WorkspaceSettings } from '../types';
import { workspaceSettingsURL } from '../workspacesURLs';

export async function getWorkspaceSettings(workspaceId: string) {
  const url = workspaceSettingsURL(workspaceId);
  const response = await axios.get<WorkspaceSettings>(url.href);
  return response.data;
}
